import { Music2 } from 'lucide-react';

interface LyricPillProps {
  lyricText: string;
  showLabel?: boolean;
}

export default function LyricPill({ lyricText, showLabel = true }: LyricPillProps) {
  return (
    <div className="w-full max-w-[500px] mx-auto">
      {showLabel && (
        <div className="section-label text-[9px] text-[#40E0D0] mb-2 text-center">
          Lyric Spotlight
        </div>
      )}
      <div
        className="bg-[#1A1A1A] backdrop-blur-sm rounded-2xl px-5 py-4 border"
        style={{ borderColor: 'rgba(255, 255, 255, 0.08)', boxShadow: '0px 12px 28px 3px rgba(0, 0, 0, 0.52), 0px 2px 8px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 1px rgba(255, 255, 255, 0.04), inset 0px -1px 2px rgba(0, 0, 0, 0.22)' }}
        aria-label="Lyric from this song"
      >
        <div className="flex items-center justify-center gap-2">
          <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#40E0D0]/10 flex items-center justify-center">
            <Music2
              className="w-3 h-3 text-[#40E0D0]"
              aria-hidden="true"
              strokeWidth={2}
            />
          </div>
          <p className="lyric-text text-[15px] text-[#F5F5F5] leading-relaxed">
            "{lyricText}"
          </p>
        </div>
      </div>
    </div>
  );
}
